export const railsClassNameMapper = {
  noticeChannel: 'Message::NoticeChannel'
};